import { IWidgets } from "../../../../models/master/widgets";
import { baseURL } from "../../../../constants/commonConstants";
import { ICampusEvents } from "../../../../models/dashboard/staffDashboard";
import { connect, useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { limit, pageBlockId } from "../../../../constants/pageBlocks";
import { setWidgets } from "../../../../store/slices/master/widgetSlice";
import { getWidgets } from "../../../../action/masters/widgetActionCreator";
import { useNavigate } from "react-router-dom";
import { ROUTER_URL } from "../../../../constants/routerUrl";
import { getPageBlockData } from "../../../../common-functions/commonFunctions";

const CampusEvents = (props: ICampusEvents) => {
  const { getCampusEvents, campusEvents, snapShots } = props;
  const [visibleEvents, setVisibleEvents] = useState<IWidgets[]>([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleViewALL = () => {
    navigate(ROUTER_URL.STAFF_ALL_CAMPUS_EVENTS);
  };

  const pageBlockData = getPageBlockData(snapShots, pageBlockId.campusEvents);

  useEffect(() => {
    dispatch(setWidgets([]));
    if (pageBlockData?.displayOrNot) {
      getCampusEvents(pageBlockId.campusEvents, limit.three);
    }
  }, [pageBlockData]);

  useEffect(() => {
    setVisibleEvents(campusEvents?.slice(0, 3));
  }, [campusEvents]);

  useEffect(() => {
    return () => {
      dispatch(setWidgets([]));
    };
  }, []);

  return (
    <>
      <div
        className={
          pageBlockData?.displayOrNot ? "card-wrap" : "card-wrap card-snapshot"
        }
        style={
          pageBlockData?.displayOrNot === false
            ? { backgroundImage: `url(${baseURL + pageBlockData.image})` }
            : {}
        }
      >
        <div className="title">
          <h2>Campus Events</h2>
          <a
            onClick={handleViewALL}
            className={
              pageBlockData?.displayOrNot ? "btn-link" : "btn-link d-none"
            }
            title="View All Campus Events"
          >
            View All
          </a>
        </div>
        <ul className="transactions-wrap mt-3 mb-0">
          {visibleEvents
            ?.filter((alert: IWidgets) => alert.displayOrNot)
            .map((alert: IWidgets) => (
              <li key={alert.id}>
                <a href={alert.url} target="_blank">
                  <div className="img icon">
                    <img src={baseURL + alert.image} alt="" />
                  </div>
                  <div>
                    <h3>{alert.name}</h3>
                    <p className="para-hide-1">{alert.description}</p>
                  </div>
                </a>
              </li>
            ))}
        </ul>
      </div>
    </>
  );
};

const mapDispatchToProps = {
  getCampusEvents: (pageBlockId?: number, noOfItems?: number) =>
    getWidgets(undefined, pageBlockId, undefined, noOfItems),
};

function mapStateToProps(state: any) {
  return {
    campusEvents: state.widget.quickLinkWidget,
    snapShots: state.snapShot.snapShots,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CampusEvents);
